<template>
  <div>
    <div
      class="d-flex mx-5 mb-4 mt-2"
    >
      <img
        :class="$vuetify.breakpoint.mobile ? 'picto-mobile' : ''"
        alt="no-comparaison"
        class="mt-6 align-self-center"
        src="@/assets/no-comparaison.svg"
      >
      <div
        :class="$vuetify.breakpoint.mobile ? 'ml-3' : 'ml-5'"
        class=" align-self-center"
      >
        <v-chip
          color="secondary"
          label
        >
          <div class="texte white--text">
            Paramètres complétés
          </div>
        </v-chip>
        <div class="intro texte-gris-fonce mt-4">
          Vous pouvez désormais avoir accès aux comparaisons.
        </div>
      </div>
    </div>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'pr-2' : ''"
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Mon atelier cultures sur mon exploitation est :
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.typeExploitation.libelle }}
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'pr-2' : ''"
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Type de sol
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.typeSol.libelle }}
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Profondeur d'enracinement
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.profondeurSol }}
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Indication du potentiel de sol
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.indicePotentielSol.libelle }}
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Type de production
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.typeProduction.libelle }}
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Ressources en effluents
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.ressourceEffluent.libelle }}
      </v-col>
    </v-row>
    <v-divider class="mx-6" />
    <v-row
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Stockage céréales
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.stockageCereales.libelle }}
      </v-col>
    </v-row>
    <v-divider
      v-if="parametresExploitation.stockageCereales.code === 'VENTE'"
      class="mx-6"
    />
    <v-row
      v-if="parametresExploitation.stockageCereales.code === 'VENTE'"
      :class="$vuetify.breakpoint.mobile ? 'my-3' : 'my-6 '"
      class="ml-6"
      no-gutters
    >
      <v-col
        class="intro texte-gris-fonce"
        cols="12"
        md="6"
      >
        Capacité de stockage (t)
      </v-col>
      <v-col
        :class="$vuetify.breakpoint.mobile ? 'mt-2' : ''"
        class="intro secondary--text"
        cols="12"
        md="6"
      >
        {{ parametresExploitation.capaciteStockage }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ParametresExploitationRestitution',
  props: {
    parametresExploitation: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true
    },
    erreur: {
      type: Boolean,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.picto-mobile {
  width: 40%;
}
</style>
